import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { FiImage } from "react-icons/fi";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { useMediaQuery } from "react-responsive";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FiX } from "react-icons/fi";
import Button from "@material-ui/core/Button";

import getCroppedImg from "../../Utils/CropImage";
import { PrimaryBtn } from "../../Theme";
import Crop from "./Crop";
import "./style.css";

const Dropzone = ({
  fileChange,
  initialUrl = "",
  label = "Imagem do produto",
  aspect = 16 / 9,
  ...props
}) => {
  const [selectedFileUrl, setSelectedFileUrl] = useState(initialUrl);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [openCrop, setOpenCrop] = useState(false);
  const [croppedUrl, setCroppedUrl] = useState(initialUrl);
  const isMobile = useMediaQuery({
    query: "(max-device-width: 425px)",
  });

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      const fileUrl = URL.createObjectURL(file);
      setSelectedFileUrl(fileUrl);
      setOpenCrop(true);
    },
    [fileChange]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  function handleCloseCrop() {
    setOpenCrop(false);
  }

  const handleChangeCrop = useCallback((event) => {
    setCroppedAreaPixels(event);
  }, []);

  const cropImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        selectedFileUrl,
        croppedAreaPixels
      );
      const fileUrl = URL.createObjectURL(croppedImage);
      setCroppedUrl(fileUrl);
      fileChange(croppedImage);
      setOpenCrop(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, selectedFileUrl]);

  return (
    <>
      <div
        {...props}
        className={`dropzone ${props.className || ""}`}
        {...getRootProps()}
      >
        <input {...getInputProps()} accept="images/*" />
        {selectedFileUrl ? (
          <div className="image">
            <img src={croppedUrl} alt="thumb" />
            <span>{label}</span>
          </div>
        ) : (
          <p>
            <FiImage />
            {label}
          </p>
        )}
      </div>
      <Dialog
        fullWidth
        fullScreen={isMobile}
        open={openCrop}
        onClose={handleCloseCrop}
      >
        <DialogTitle>
          <Button
            style={{ position: "absolute", right: "10px", top: "0px" }}
            onClick={handleCloseCrop}
          >
            <FiX style={{ fontSize: "25px" }} />
          </Button>
        </DialogTitle>
        <DialogContent>
          <div class="container-crop-dialog">
            <div class="container-crop">
              <Crop
                aspect={aspect}
                onChange={handleChangeCrop}
                src={selectedFileUrl}
              />
            </div>
            <PrimaryBtn onClick={cropImage}>Recortar e salvar</PrimaryBtn>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Dropzone;
